// src/components/CanvasCaptcha.js

import React, { useRef, useState, useEffect } from 'react';
import utils from "../services/utils";

const CanvasCaptcha = ({ onVerify }) => {
    const canvasRef = useRef(null);
    const [captchaValue, setCaptchaValue] = useState('');
    const [userInput, setUserInput] = useState('');
    const [isVerified, setIsVerified] = useState(false);
    const [isFirstTry, setFirstTry] = useState(true);

    useEffect(() => {
        generateCaptcha();
    }, []);

    const generateCaptcha = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const captchaLength = 5;
        const fontSize = 25; // Consistent font size
        const characterSpacing = 3; // Space between characters
        let captcha = '';

        // Adjust canvas width based on character length, font size, and spacing
        canvas.width = captchaLength * (fontSize + 20);
        canvas.height = 50;

        // Clear the canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Set random background color
        ctx.fillStyle = '#f0f0f0';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Draw random characters on the canvas
        for (let i = 0; i < captchaLength; i++) {
            const char = characters.charAt(Math.floor(Math.random() * characters.length));
            captcha += char;

            // Random position and rotation
            const x = (i+1) * (fontSize + characterSpacing + 10); // Adjust starting x position
            const y = Math.floor(Math.random() * 10) + 30;
            const rotation = (Math.random() - 0.5) * 0.2; // Random rotation between -0.1 and 0.1 radians

            ctx.save();
            ctx.font = `${fontSize}px Arial`;
            const getReadableColor = () => {
                // Choose from a set of high-contrast colors
                const colors = ['#000000', '#003366', '#660000', '#000099', '#006600', '#333333'];
                return colors[Math.floor(Math.random() * colors.length)];
            };
            ctx.fillStyle = getReadableColor();
            ctx.translate(x, y);
            ctx.rotate(rotation);
            ctx.fillText(char, 0, 0);
            ctx.restore();
        }

        // Store the generated captcha value
        setCaptchaValue(captcha);
    };

    const handleInputChange = (e) => {
        setUserInput(e.target.value);
    };

    const handleVerify = () => {
        if(isFirstTry) setFirstTry(false);
        if (userInput === captchaValue) {
            setIsVerified(true);
            onVerify(true);
        } else {
            onVerify(false);
        }
    };

    return (
        <div>
            {!isVerified &&<canvas ref={canvasRef} height="50" className={"reg-canvas"} style={{ border: '1px solid #ccc' }}></canvas>}
            {!isVerified &&<input
                className={'login-inp'}
                type="text"
                value={userInput}
                onChange={handleInputChange}
                disabled={isVerified}
                placeholder={utils.useLang('ENTER_CAPTCHA')}
                style={{ letterSpacing: '2px', fontWeight: 'bold', marginTop: '10px' }}
            />}
            {!isVerified && <div>
                <button className={'login-btn'} onClick={generateCaptcha}>{utils.useLang('REFRESH')}</button>
                <button  className={'login-btn'} onClick={handleVerify}  disabled={isVerified}>{utils.useLang('VERIFY')}</button>
            </div>}
            <div className={'code-check-result'}>
                {isVerified === true && <p>{utils.useLang('APPROVED_CODE')}</p>}
                {!isVerified && !isFirstTry && <p>{utils.useLang('DECLINED_CODE')}</p>}
            </div>
        </div>
    );
};

export default CanvasCaptcha;
